// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
// import Backend from 'i18next-http-backend';

// // i18next Configuration
// i18n
//   .use(Backend)
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     fallbackLng: 'en', // Default language
//     debug: true,
//     interpolation: {
//       escapeValue: false,
//     },
//     backend: {
//       loadPath: '/assets/locales/{{lng}}/translation.json',
//     },
//     detection: {
//       order: ['localStorage', 'navigator'], // Detect language from localStorage or browser
//       caches: ['localStorage'],
//     },
//     supportedLngs: ['en', 'es', 'ar'], // Add Arabic (ar) as a supported language
//   });

// export default i18n;


import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// i18next Configuration
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en', // Default language
    debug: true,
    interpolation: {
      escapeValue: false, // React already escapes strings
    },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['localStorage', 'navigator'], // Detect language from localStorage or browser
      caches: ['localStorage'],
    },
    supportedLngs: ['en', 'es', 'ar'], // Add Arabic (ar) as a supported language
  });

// Ensure LTR layout for both English and Arabic
const setLayoutDirection = (lng: string) => {
  // Force LTR layout, even when the language is Arabic
  document.body.classList.remove('rtl');
  document.body.classList.add('ltr');
};

i18n.on('languageChanged', (lng) => {
  setLayoutDirection(lng); // Ensure layout stays LTR for both English and Arabic
});

export default i18n;
